import { useEffect, useRef } from "react";
import { sendOrderSuccess } from "../../service/orderService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { baseURL } from "api/apiService";
import Format from "utils/Format";
import { formatDate } from "./printService";

const printServiceReceipt = (metaData, context) => {
  // let ePos = new window.epson.ePOSDevice();
  //   const canvasRef = useRef(null);
  const _user = localStorage.getItem("Apec_Account");
  console.log("metaData", metaData);
  const user = _user && JSON.parse(_user);
  var image = "";
  const groupBy = (xs, key) => {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  const wrapText = (text, maxLength) => {
    const words = text.split(" ");
    let result = [];
    let line = "";

    words.forEach((word) => {
      if (line.length + word.length + 1 <= maxLength) {
        line += (line.length > 0 ? " " : "") + word;
      } else {
        result.push(line);
        line = word;
      }
    });
    if (line.length > 0) {
      result.push(line);
    }
    return result;
  };

  const padRight = (text, length) => {
    return text?.padStart(length, " ");
  };

  const padLeft = (text, length) => {
    return text?.padEnd(length, " ");
  };

  const createRequestData = (items) => {
    var builder = new window.epson.ePOSBuilder();
    // Create a print document
    console.log("context", context);
    builder.addTextLang("en");
    builder.addTextSmooth(true);
    builder.addTextFont(builder.FONT_C);
    builder.addTextSize(2, 2);
    builder.addTextAlign(builder.ALIGN_CENTER);
    builder.addText(metaData?.hotelDetail.hotelName + "\n\n");
    builder.addTextAlign(builder.ALIGN_LEFT);
    builder.addTextFont(builder.FONT_A);
    builder.addTextSize(1, 1);
    builder.addText("Website: " + metaData?.hotelDetail.website + "\n");
    // builder.addTextSize(1, 1);
    builder.addText("Add: " + metaData?.hotelDetail.address + "\n");
    // builder.addTextSize(1, 1);
    builder.addText(
      "Tax code: " +
        metaData?.hotelDetail.taxCode +
        "\t" +
        "Hotline: " +
        metaData?.hotelDetail.phone +
        "\n"
    );
    // builder.addTextSize(1, 1);
    builder.addText("------------------------------------------------\n");
    builder.addTextAlign(builder.ALIGN_CENTER);
    builder.addTextSize(2, 2);
    builder.addTextFont(builder.FONT_C);
    builder.addText("Receipt TEST\n\n");
    builder.addTextAlign(builder.ALIGN_LEFT);
    builder.addTextSize(1, 1);
    builder.addTextFont(builder.FONT_B);

    builder.addText(
      "Date: " +
        items[0].order_time +
        "\t" +
        "Outlet: " +
        items[0].rvcname +
        "\n"
    );
    builder.addTextSize(1, 1);
    builder.addText(
      "Order: " +
        items[0].order_no +
        "\t\t" +
        "Guest: " +
        `${metaData?.totalGuest}\t\t\n\n` || ""
    );
    builder.addTextStyle(false, false, true);
    builder.addText(
      "No" +
        "  " +
        "Items" +
        "\t\t   " +
        "Unit" +
        "    " +
        "Qty" +
        "   " +
        "Price" +
        "       " +
        "Amount" +
        "\n"
    );
    builder.addHLine(0, 200, builder.LINE_THIN_DOUBLE);
    builder.addTextFont(builder.FONT_A);
    builder.addTextStyle(false, false, false);
    let indexItem = 0;
    items.forEach((item, index) => {
      indexItem += 1;
      console.log("item ===", item);

      let wrappedText = wrapText(item.iname, 14);
      //   console.log("wrappedText ==", wrappedText);
      wrappedText.forEach((line, lineIndex) => {
        if (lineIndex === 0) {
          const length = 16 - line.length || 0;
          if (length > 0) {
            for (let i = 0; i < length; i++) {
              line += " ";
            }
          }
          //   console.log("line ===", line);
          builder.addText(indexItem + " " + line);
          builder.addText(
            padLeft(item.unit?.trim(), 4) +
              "  " +
              padLeft(`${item.quanitity || 0}`?.trim(), 3) +
              " " +
              padLeft(`${item.price ? item.price : ""}`?.trim(), 9) +
              (item.price ? item.price * item.quanitity : "") +
              "\n"
          );
        } else {
          builder.addText("   " + line + "\n");
        }
      });
      builder.addText("------------------------------------------------\n");
      isPrint = true;
    });
    builder.addTextStyle(false, false, true);
    builder.addTextFont(builder.FONT_A);
    builder.addTextSize(1, 1);
    builder.addTextPosition(0);
    builder.addText(
      "TotalAtm: " +
        padRight(Format.formatMoneyNotD(metaData?.totalAmount) + " VNĐ", 33) +
        "\n"
    );

    builder.addTextPosition(0);
    builder.addText(
      "DiscountAtm: " +
        padRight(Format.formatMoneyNotD(metaData?.billDiscount) + " VNĐ", 30) +
        "\n"
    );

    builder.addTextPosition(0);
    builder.addText(
      "Sub Total: " +
        padRight(Format.formatMoneyNotD(metaData?.subTotal) + " VNĐ", 32) +
        "\n"
    );

    builder.addTextPosition(0);
    builder.addText(
      "Service Charge: " +
        padRight(Format.formatMoneyNotD(metaData?.serviceCharge) + " VNĐ", 27) +
        "\n"
    );

    builder.addTextPosition(0);
    builder.addText(
      "VAT: " +
        padRight(Format.formatMoneyNotD(metaData?.tax) + " VNĐ", 38) +
        "\n"
    );

    builder.addTextPosition(0);
    builder.addText(
      "TTDB: " +
        padRight(Format.formatMoneyNotD(metaData?.ttdb) + " VNĐ", 37) +
        "\n"
    );

    builder.addTextPosition(0);
    builder.addText(
      "Total: " +
        padRight(Format.formatMoneyNotD(metaData?.total) + " VNĐ", 36) +
        "\n"
    );

    builder.addText("------------------------------------------------\n");
    builder.addTextStyle(false, false, false);
    builder.addTextPosition(0);
    builder.addText(
      "Amount paid: " +
        padRight(Format.formatMoneyNotD(metaData?.amountPaid) + " VNĐ", 30) +
        "\n"
    );

    builder.addTextPosition(0);
    builder.addText(
      "Due back: " +
        padRight(Format.formatMoneyNotD(metaData?.dueBack) + " VNĐ", 33) +
        "\n"
    );

    builder.addTextPosition(0);
    builder.addText(
      "Payment method: " +
        (metaData?.paymentMethod ? metaData?.paymentMethod : "") +
        "\n\n\n"
    );

    builder.addTextAlign(builder.ALIGN_CENTER);
    if (context?.getImageData)
      builder.addImage(context, 0, 0, 250, 250, builder.COLOR_1);
    builder.addText("\n\n");
    builder.addText("\t\t\t" + "Guest signature \n\n\n");
    builder.addText("\n\n\n\n");
    builder.addTextStyle(false, false, true);
    builder.addTextAlign(builder.ALIGN_CENTER);
    builder.addText("Thank you and See you again!\n");
    builder.addText("------------------------------------------------\n");
    builder.addText(
      "Print Date: " +
        formatDate(metaData?.printDate || "") +
        "  -  Staff: " +
        user
    );
    builder.addCut(builder.CUT_FEED);

    return builder.toString();
  };
  var isPrint = false;
  let xml = "";
  if (metaData.itemsends && metaData.itemsends.length > 0) {
    let dataGroup = groupBy(metaData.itemsends, "ipaddress");
    let ipList = Object.keys(dataGroup);
    console.log("ipList", ipList);
    ipList.forEach((ip, index) => {
      isPrint = false;
      let items = dataGroup[ip];
      const itemIds = items.map((i) => i.item_id).join(",");
      console.log("items", items);
      //   xml =
      //     '<?xml version="1.0" encoding="utf-8"?><s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/"><s:Body>' +
      //     createRequestData(items) +
      //     "</s:Body></s:Envelope>";
      if (items.length > 0) {
        let request =
          '<?xml version="1.0" encoding="utf-8"?><s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/"><s:Body>' +
          createRequestData(items) +
          "</s:Body></s:Envelope>";
        const _request = request.replaceAll('"', "'");
        console.log("request", _request);
        if (isPrint) {
          // epos.send(request);
          //   .post("https://kb.mandalahotel.com.vn/booking/api/print/send", {
          //     data: _request,
          //     ip: "10.10.40.252",
          //   })
          axios
            .post(baseURL + "booking/api/print/send", {
              data: _request,
              ip: ip,
              //   ip: "10.10.40.252",
            })
            .then(function (response) {
              if (response.data) {
                switch (response.data) {
                  case "NO_CONNECTION":
                    toast.error(
                      `[${items[0].printeR_NAME}]` + "Máy in đang offline",
                      {
                        position: "top-right",
                        theme: "colored",
                      }
                    );
                    return;
                  case "SUCCESS":
                    toast.success(
                      `[${items[0].printeR_NAME}]` + "In order thành công !",
                      {
                        position: "top-right",
                        theme: "colored",
                      }
                    );
                    sendOrderSuccess({
                      orderNo: items[0].order_no,
                      itemIds: itemIds,
                    });
                    return;
                  case "FAILED":
                    toast.error(
                      `[${items[0].printeR_NAME}]` +
                        "In order thất bại. Vui lòng kiểm tra Wifi và thử lại !",
                      {
                        position: "top-right",
                        theme: "colored",
                      }
                    );
                    return;
                  case "EPTR_REC_EMPTY":
                    toast.error(`[${items[0].printeR_NAME}]` + "Hết giấy", {
                      position: "top-right",
                      theme: "colored",
                    });
                    return;
                  default:
                    return;
                }
              }
            })
            .catch(function (error) {
              toast.error(`[${items[0].printeR_NAME}]` + "In thất bại", {
                position: "top-right",
                theme: "colored",
              });
            });
          // var a = 'http://20.208.210.164/booking/api/print/send';
          //   toast.warn(`[${items[0].printeR_NAME}]` + "Đang in...", {
          //     position: "top-right",
          //     theme: "colored",
          //   });
        } else {
          // No Item to send
          // toast.error('Không có item để in', {
          //     position: 'top-right',
          //     theme: 'colored'
          // });
        }
      }
    });
    // console.log("xml ===", xml);
    // return xml;
  }
};

export default printServiceReceipt;
